module.exports = __webpack_public_path__ + "assets/retina_TrBySideAndCentroidDetailed.37934f3b0452492cd2e9a53380861cb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_TrBySideAndCentroidDetailed.png
// module id = 743
// module chunks = 0